import NewsletterGoodMorningCtrl from "./NewsletterGoodMorningCtrl";
import UserManager from "../business/UserManager";
import GigyaManager from "../business/GigyaManager";
import $ from 'jquery';
import Pristine from "pristinejs/dist/pristine";
import GoogleAnalytics from "../business/GoogleAnalytics";

class NewsletterTreNACConfermaCtrl extends NewsletterGoodMorningCtrl {
    constructor(element) {
        super(element);
        this.pristine = '';
        this.$el = $(this.element);
        this.initForm();
        this.toggleInput();
    }

    initForm(){
        let form = document.getElementById("newsletter-good-morning");

        let formConfig = {
            // class of the parent element where the error/success class is added
            classTo: 'newsletter-good-morning__radio-container',
            errorClass: 'error',
            successClass: 'has-success',
            // class of the parent element where error text element is appended
            errorTextParent: 'newsletter-good-morning__radio-container',
            // type of element to create for the error text
            errorTextTag: 'span',
            // class of the error text element
            errorTextClass: 'error-field'
        };

        // create the pristine instance
        this.pristine = new Pristine(form, formConfig);
    }


    sendForm() {
        let newsletter3nacVal = $('input[name="newsletter-goodmorning"]:checked').val();

        if (newsletter3nacVal) {
            let choiceSelected = [newsletter3nacVal];

            UserManager.getLoggedUser().then((d) => {
                let params = {
                    subscriptions: {},
                    callback: (data) => {
                        if (data.status === "OK") {
                            window.location.href = "/newsletter-thank-you";
                        }
                    }
                };

                if(newsletter3nacVal){
                    params.subscriptions.NL_3NAC = {
                        email: {
                            isSubscribed: true,
                            tags: choiceSelected
                        }
                    }

                    params.subscriptions.NL_goodmorning = {
                        email: {
                            isSubscribed: false,
                            tags: []
                        }
                    }
                }

                GigyaManager.setAccountInfo(params);

                const obj = {
                    'data-form-id': 'newsletter-3nac',
                    'data-form-name': 'newsletter 3nac'
                }

                GoogleAnalytics.send('form_submitted', obj);
            }, () => {
                // save values in localstorage
                localStorage.setItem("newsletter-goodmorning", newsletter3nacVal);
                localStorage.setItem("newsletter-goodmorning-redirect", "false");
                window.location.href = "/login?regSource=893";
            });


        }else{
            $(".newsletter-good-morning__radio-container").append('<span class="pristine-error error-field" id="error-tre-notizie">Per iscriverti ad una delle newsletter Mulino Bianco è necessario compilare uno dei campi</span>');
        }
    }

}

export default NewsletterTreNACConfermaCtrl;
